module.exports = __webpack_public_path__ + "69470dc65e0c1e1fc539c0b6a03570c5.pdf";